import React, { useState, useEffect, useCallback } from "react";
import api from "./../../api.js";
import Dashheader from "../Dashboard/Dashheader/Dashheader.jsx";
import './consolatedreport.css';

const Consalatedreport = () => {
    const [customerlist, setCustomerList] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [view, setView] = useState('table');
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState('table');
    const [sortConfig, setSortConfig] = useState({ key: 'totalAmount', direction: 'desc' });
    // Removed filterConfig, showFilters, and dateRange as filters are not needed

    const fetchCustomerList = useCallback(async () => {
        setLoading(true);
        try {
            let response = await api.getConsolatedReport(searchTerm);
            const result = Array.isArray(response?.data?.data) ? response.data.data : [];
            setCustomerList(result);
        } catch (error) {
            console.error("Error fetching customer details:", error);
            setCustomerList([]);
        } finally {
            setLoading(false);
        }
    }, [searchTerm]);

    useEffect(() => {
        fetchCustomerList();
    }, [fetchCustomerList]);

    const handleTabChange = (tab) => {
        setActiveTab(tab);
        setView(tab);
    };

    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    // Removed handleFilterChange and applyFilters

    // Sort the data
    const sortedData = [...customerlist].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
    });

    // No filters, so filteredData is just sortedData
    const filteredData = sortedData;

    const totalSum = filteredData.reduce((sum, item) => sum + item.totalAmount, 0);
    const totalGst = filteredData.reduce((sum, item) => sum + item.totalPaidGstAmount, 0);
    const totalPayable = filteredData.reduce((sum, item) => sum + item.totalPayableAmount, 0);
    const totalWithoutGst = filteredData.reduce((sum, item) => sum + item.totalPaidWithoutGst, 0);

    // Format currency
    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(amount);
    };

    // Get the sort icon
    const getSortIcon = (key) => {
        if (sortConfig.key !== key) return '↕️';
        return sortConfig.direction === 'asc' ? '↑' : '↓';
    };

    // Export functionality
    const exportToCSV = () => {
        const headers = ['Name', 'Email', 'Phone',  'Flat Value','Paid Amount', 'GST Amount', 'Payable Amount'];
        const data = filteredData.map(c => [
            c.name,
            c.emailId,
            c.phoneNumber,
            c.totalAmount,
            c.totalPaidWithoutGst,
            c.totalPaidGstAmount,
            
            c.totalPayableAmount
        ]);
        
        const csvContent = [
            headers.join(','),
            ...data.map(row => row.join(','))
        ].join('\n');
        
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', 'consolidated_report.csv');
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    // Add this to your component
useEffect(() => {
    // Function to handle scroll for showing/hiding scroll-to-top button
    const handleScroll = () => {
        const scrollButton = document.querySelector('.scroll-top-button');
        if (scrollButton) {
            if (window.pageYOffset > 300) {
                scrollButton.classList.add('visible');
            } else {
                scrollButton.classList.remove('visible');
            }
        }
    };

    // Add scroll event listener
    window.addEventListener('scroll', handleScroll);
    
    // Clean up
    return () => {
        window.removeEventListener('scroll', handleScroll);
    };
}, []);

    return (
        <>
            <Dashheader />
            <div className="consolatedreport-container">
                <div className="consolatedreport-header">
                    <h2 className="consolatedreport-title">Consolidated Report</h2>
                    <div className="consolatedreport-actions">
                        <button className="consolatedreport-export-btn" onClick={exportToCSV}>
                            <span className="icon">📊</span> Export CSV
                        </button>
                    </div>
                </div>
               
<div 
    className="scroll-top-button" 
    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
>
    ↑
</div>



                
                {/* Summary Cards */}
                <div className="summary-cards-container">
                    <div className="summary-card">
                        <div className="summary-card-icon">💰</div>
                        <div className="summary-card-content">
                            <h3>Total Amount</h3>
                            <div className="summary-amount">{formatCurrency(totalSum).replace('₹', '₹ ')}</div>
                        </div>
                    </div>
                    
                    
                    <div className="summary-card">
                        <div className="summary-card-icon">📈</div>
                        <div className="summary-card-content">
                            <h3>Recieved Amount</h3>
                            <div className="summary-amount">{formatCurrency(totalWithoutGst).replace('₹', '₹ ')}</div>
                        </div>
                    </div>
                    
                    <div className="summary-card">
                        <div className="summary-card-icon">🧾</div>
                        <div className="summary-card-content">
                            <h3>GST Amount</h3>
                            <div className="summary-amount">{formatCurrency(totalGst).replace('₹', '₹ ')}</div>
                        </div>
                    </div>
                    
                    <div className="summary-card">
                        <div className="summary-card-icon">👥</div>
                        <div className="summary-card-content">
                            <h3>Customer Count</h3>
                            <div className="summary-amount">{filteredData.length}</div>
                        </div>
                    </div>
                </div>

                {/* Filters Panel removed */}

                <div className="consolatedreport-searchbar">
                    <input
                        type="text"
                        placeholder="Search by name, email or phone..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="consolatedreport-input"
                    />
                    <button onClick={fetchCustomerList} className="consolatedreport-button">
                        <span className="button-icon">🔍</span> Search
                    </button>
                </div>

                <div className="consolatedreport-toggle">
                    <button 
                        className={activeTab === 'table' ? 'active' : ''} 
                        onClick={() => handleTabChange('table')}
                    >
                        <span className="tab-icon">📋</span> Table View
                    </button>
                    <button 
                        className={activeTab === 'bar' ? 'active' : ''} 
                        onClick={() => handleTabChange('bar')}
                    >
                        <span className="tab-icon">📊</span> Bar Chart
                    </button>
                    <button 
                        className={activeTab === 'pie' ? 'active' : ''} 
                        onClick={() => handleTabChange('pie')}
                    >
                        <span className="tab-icon">🥧</span> Pie Chart
                    </button>
                </div>

                {loading ? (
                    <div className="loading-container">
                        <div className="loading-spinner"></div>
                        <p>Loading data...</p>
                    </div>
                ) : filteredData.length > 0 ? (
                    <>
                        {view === 'table' && (
                            <div className="consolatedreport-table-wrapper">
                                <table className="consolatedreport-table">
                                    <thead>
                                        <tr>
                                            <th onClick={() => handleSort('name')}>
                                                Customer {getSortIcon('name')}
                                            </th>
                                            <th onClick={() => handleSort('emailId')}>
                                                Email {getSortIcon('emailId')}
                                            </th>
                                            <th onClick={() => handleSort('phoneNumber')}>
                                                Phone {getSortIcon('phoneNumber')}
                                            </th>
                                            <th onClick={() => handleSort('totalAmount')}>
                                                Total Amount {getSortIcon('totalAmount')}
                                            </th>
                                            <th onClick={() => handleSort('totalPaidWithoutGst')}>
                                                Recieved Amount {getSortIcon('totalPaidWithoutGst')}
                                            </th>
                                            <th onClick={() => handleSort('totalPayableAmount')}>
                                                Receivable Amount {getSortIcon('totalPayableAmount')}
                                            </th>
                                            <th onClick={() => handleSort('totalPaidGstAmount')}>
                                                GST {getSortIcon('totalPaidGstAmount')}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredData.map((c, idx) => (
                                            <tr key={c._id}>
                                                <td>
                                                    <div className="customer-info">
                                                        <div className="customer-avatar">
                                                            {idx + 1}
                                                        </div>
                                                        <div className="customer-name">{c.name}</div>
                                                    </div>
                                                </td>
                                                <td>{c.emailId}</td>
                                                <td>{c.phoneNumber}</td>
                                                <td>
                                                    <span className="amount-highlight">
                                                        {formatCurrency(c.totalAmount).replace('₹', '₹ ')}
                                                    </span>
                                                </td>
                                                <td>{formatCurrency(c.totalPaidWithoutGst).replace('₹', '₹ ')}</td>
                                                <td>{formatCurrency(c.totalPayableAmount).replace('₹', '₹ ')}</td>
                                                <td>{formatCurrency(c.totalPaidGstAmount).replace('₹', '₹ ')}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td colSpan="3"><strong>Total</strong></td>
                                            <td><strong>{formatCurrency(totalSum).replace('₹', '₹ ')}</strong></td>
                                            <td><strong>{formatCurrency(totalWithoutGst).replace('₹', '₹ ')}</strong></td>
                                            <td><strong>{formatCurrency(totalPayable).replace('₹', '₹ ')}</strong></td>
                                            <td><strong>{formatCurrency(totalGst).replace('₹', '₹ ')}</strong></td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        )}

                        {view === 'bar' && (
                            <div className="consolatedreport-bar-chart">
                                <div className="chart-header">
                                    <h3>Revenue Distribution</h3>
                                    <div className="chart-legend">
                                        <span className="legend-item">
                                            <span className="legend-color" style={{background: 'linear-gradient(90deg, #6366f1 0%, #4f46e5 100%)'}}></span>
                                            <span>Total Amount</span>
                                        </span>
                                        <span className="legend-item">
                                            <span className="legend-color" style={{background: 'linear-gradient(90deg, #22c55e 0%, #16a34a 100%)'}}></span>
                                            <span>Paid Amount</span>
                                        </span>
                                    </div>
                                </div>
                                <div style={{width: 300, margin: '0 auto', padding: 16}}>
                                    {/* Single bar for all customers */}
                                    <svg width="220" height="220">
                                        {/* Total Amount Bar */}
                                        <rect x="60" y="60" width="40" height="120" fill="#e5e7eb" rx="8" />
                                        <rect x="60" y={60 + 120 - 160 * (totalSum > 0 ? 1 : 0)} width="40" height={160 * (totalSum > 0 ? 1 : 0)} fill="#6366f1" rx="8" />
                                        {/* Paid Amount Bar */}
                                        <rect x="120" y="60" width="40" height="120" fill="#e5e7eb" rx="8" />
                                        <rect x="120" y={60 + 120 - 160 * (totalSum > 0 ? totalWithoutGst / totalSum : 0)} width="40" height={160 * (totalSum > 0 ? totalWithoutGst / totalSum : 0)} fill="#22c55e" rx="8" />
                                        {/* Labels */}
                                        <text x="80" y="200" textAnchor="middle" fontSize="14" fill="#222">Total</text>
                                        <text x="140" y="200" textAnchor="middle" fontSize="14" fill="#222">Paid</text>
                                        <text x="80" y={60 + 120 - 160 * (totalSum > 0 ? 1 : 0) - 8} textAnchor="middle" fontSize="12" fill="#6366f1">{formatCurrency(totalSum).replace('₹', '₹ ')}</text>
                                        <text x="140" y={60 + 120 - 160 * (totalSum > 0 ? totalWithoutGst / totalSum : 0) - 8} textAnchor="middle" fontSize="12" fill="#22c55e">{formatCurrency(totalWithoutGst).replace('₹', '₹ ')}</text>
                                    </svg>
                                </div>
                            </div>
                        )}

                        {view === 'pie' && (
                            <div className="consolatedreport-pie-container">
                                <div className="chart-header">
                                    <h3>Revenue Share</h3>
                                    <div className="chart-legend">
                                        <span className="legend-item">
                                            <span className="legend-color" style={{background: '#6366f1'}}></span>
                                            <span>Total Amount</span>
                                        </span>
                                        <span className="legend-item">
                                            <span className="legend-color" style={{background: '#22c55e'}}></span>
                                            <span>Paid Amount</span>
                                        </span>
                                    </div>
                                </div>
                                <div className="consolatedreport-pie-chart" style={{position: 'relative', width: 320, height: 320, margin: '0 auto'}}>
                                    {/* Single pie chart for all customers */}
                                    <svg width="320" height="320" viewBox="0 0 320 320">
                                        {/* Total Amount Pie (background) */}
                                        <circle
                                            cx="160"
                                            cy="160"
                                            r="120"
                                            fill="#e5e7eb"
                                        />
                                        <circle
                                            cx="160"
                                            cy="160"
                                            r="120"
                                            fill="none"
                                            stroke="#6366f1"
                                            strokeWidth="32"
                                            strokeDasharray={`${2 * Math.PI * 120}`}
                                            strokeDashoffset={0}
                                            style={{transition: 'stroke-dashoffset 0.5s'}}
                                        />
                                        {/* Paid Amount Pie (foreground) */}
                                        <circle
                                            cx="160"
                                            cy="160"
                                            r="80"
                                            fill="#e5e7eb"
                                        />
                                        <circle
                                            cx="160"
                                            cy="160"
                                            r="80"
                                            fill="none"
                                            stroke="#22c55e"
                                            strokeWidth="32"
                                            strokeDasharray={`${2 * Math.PI * 80}`}
                                            strokeDashoffset={`${2 * Math.PI * 80 * (1 - (totalSum > 0 ? totalWithoutGst / totalSum : 0))}`}
                                            style={{transition: 'stroke-dashoffset 0.5s'}}
                                        />
                                    </svg>
                                    {/* Center Labels */}
                                    <div style={{position: 'absolute', top: 0, left: 0, width: 320, height: 320, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', pointerEvents: 'none'}}>
                                        <div style={{fontWeight: 600, fontSize: 18, color: '#222'}}>Total: {formatCurrency(totalSum).replace('₹', '₹ ')}</div>
                                        <div style={{fontWeight: 600, fontSize: 18, color: '#22c55e'}}>Paid: {formatCurrency(totalWithoutGst).replace('₹', '₹ ')}</div>
                                        <div style={{fontSize: 15, color: '#222'}}>Paid %: {totalSum > 0 ? ((totalWithoutGst / totalSum) * 100).toFixed(1) : 0}%</div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </>
                ) : (
                    <div className="empty-state">
                        <div className="empty-icon">📊</div>
                        <h3>No customer data available</h3>
                        <p>Try adjusting your search or add new customers to see data here.</p>
                        <button 
                            className="consolatedreport-button-secondary" 
                            onClick={() => {
                                setSearchTerm('');
                                fetchCustomerList();
                            }}
                        >
                            Reset Search
                        </button>
                    </div>
                )}
                
                <div className="consolatedreport-footer">
                    <div className="footer-info">
                        <p>Showing {filteredData.length} of {customerlist.length} customers</p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Consalatedreport;
